module.exports = __webpack_public_path__ + "static/media/zapier-logo@2x.3e5e512e.png";